<script>

    import {createEventDispatcher} from "svelte";
    import {Splide, SplideSlide} from "@splidejs/svelte-splide";
    import {mediaUrlStore, publishConfigStore} from "./core/app-store.js";
    import {
        addToCart,
        cartTotalStore,
        decrementItemInCart,
        incrementItemInCart
    } from "./cart/cart-store.js";
    import {t} from "./core/i18n/language-store.js";
    const dispatch = createEventDispatcher();

    export let record;
    const publishConfig = M.publishConfig;
    const tenantKey = M.tenantKey;

    let videoUnmuted = publishConfig.videoUnmuted === true;
    let autoplayVideo = publishConfig.autoplayVideo === true;
    let loopVideo = publishConfig.loopVideo === true;
    let hideVideoControls = publishConfig.hideVideoControls === true;

    function close() {
        fullscreen = false;
        dispatch('close', {});
    }

    let fullscreen = false;
    function toggleFullscreenMedia() {
        fullscreen = !fullscreen;
    }

    function toggleFavorite () {
        record.isFavorite = !record.isFavorite;
        dispatch('toggleFavorite', {recordId: record.id, isFavorite: record.isFavorite});
    }

</script>

<style>
    .details-block {
        position: fixed;
        min-height: 100vh;
        width: 100vw;
        background: var(--bg-color);
        padding-bottom: 1rem;
        overflow: scroll;
        top: 0;
        bottom: 0;
    }
    .details-block--cart-not-empty {
        padding-bottom: 4rem;
    }
    .close-button {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 10;
        background: var(--bg-color);
        border-bottom-right-radius: 1.5rem;
        padding: 1.5rem 1rem 0.85rem 1.5rem;
        font-size: 1.25rem;
    }
    .media-block {
        margin: .75rem .75rem 0 .75rem;
        overflow: hidden;
        min-height: 2.5rem;
    }
    .image,
    .video {
        background: var(--no-media-color);
        width: 100%;
        height: 58vh;
        max-height: 58vh;
        object-fit: cover;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .video video {
        object-fit: cover;
        overflow: clip;
        height: 100%;
        width: 100%;
    }
    .info-block {
        padding: 0 1.25rem;
    }
    .title {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding-top: 1rem;
        padding-bottom: 0.5rem;
    }
    h2 {
        font-weight: 500;
        margin: 0;
        padding: 0;
    }
    .add-favorite {
        background: var(--fav-bg-color);
        border-radius: 50%;
        width: 2.25rem;
        height: 2.25rem;
        min-width: 2.25rem;
        min-height: 2.25rem;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: background .2s ease-in-out;
    }
    .add-favorite--active {
        background: var(--fav-color);
        color: var(--fav-font-color);
    }

    p {
        font-size: .8rem;
        line-height: 1.3rem;
        font-weight: 500;
        letter-spacing: .2px;
    }

    .nutritional {
        display: flex;
        gap: 1rem;
        color: var(--chips-font-color);
        font-size: .9rem;
    }
    .nutritional > div {
        flex-basis: 30vw;
        text-align: center;
        background: var(--chips-bg-color);
        border-radius: 0.5rem;
        padding: 0.5rem;
    }

    .allergens {
        font-size: .9rem;
        letter-spacing: .3px;
    }

    .prices-block {
        display: flex;
        flex-direction: column;
        gap: 0.75rem;
    }
    .price-item  {
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        width: 100%;
        border: none;
        color: var(--price-item-font-color);
        border-radius: 1.75rem;
        font-size: .9rem;
        box-shadow: 0 6px 9px 4px rgb(0 0 0 / 8%);
    }
    .price-item button {
        padding: 1.2rem;
        border: none;
        border-top-right-radius: 1.75rem;
        border-bottom-right-radius: 1.75rem;
        color: inherit;
        font-size: inherit;
        font-family: inherit;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: .5px;
    }
    .price-item,
    .price-item button {
        background-color: var(--price-item-bg-color);
    }
    .price-item--secondary,
    .price-item--secondary button {
        background-color: var(--secondary-price-item-bg-color);
    }
    .price-item .price-label {
        flex: 1 1;
        text-align: initial;
        color: var(--price-label-font-color);
        letter-spacing: .5px;
        padding-left: 1.2rem;
    }
    .price-item .inc-button {
        line-height: 1;
        font-size: 1.2rem;
        padding: 1.2rem 1rem;
        display: inline-flex;
    }
</style>

{#if (record) }

<div class="details-block layer-details {$cartTotalStore.count > 0 ? 'details-block--cart-not-empty' : ''}">

    <!-- CLOSE BUTTON -->
    <div class="close-button" on:click={close}>
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-ArrowLeft"><path d="M11 5l-7 7 7 7"/><path d="M4 12h16"/></svg>
    </div>

    <!-- MEDIA -->
    <div id="media" class="media-block {fullscreen ? 'media-block--full-screen' : ''} {!record?.media ? 'media-block--no-media' : ''}">

        <!-- SLIDER -->
        <Splide aria-label="{record?.name}" style="height: 100% !important; max-height: 100% !important">

            {#if (record?.media || []).length === 0}
                <SplideSlide>
                    <div class="image">
                        <img class="media-fallback" src="./images/fallback-image.svg" alt="{record?.name}" loading="lazy">
                    </div>
                </SplideSlide>
            {/if}

            {#each (record?.media || []) as media}
            <SplideSlide>
                {#if (media.type === 'photo')}

                    <object class="image" data="{$mediaUrlStore}{media.ref || tenantKey}/_media_files/{media.name}" type="image/png">
                        <img class="media-fallback" src="./images/fallback-image.svg" alt="{record?.name}">
                    </object>
                {/if}
                {#if (media.type === 'video')}
                    <div class="video">
                        <video loading="lazy"
                               muted={!videoUnmuted}
                               autoplay={autoplayVideo}
                               loop={loopVideo}
                               controls={!hideVideoControls}>
                            <source src="{$mediaUrlStore}{media.ref || tenantKey}/_media_files/{media.name}" type="video/mp4">
                            <track kind="captions">
                        </video>
                    </div>
                {/if}
            </SplideSlide>
            {/each}
        </Splide>

    </div>

    <!-- INFO BLOCK -->
    <div class="info-block">

        <!-- title -->
        <div class="title flex-between">
            <h2>{ record?.name || '' }</h2>

            <div class="add-favorite {record.isFavorite ? 'add-favorite--active' : ''}" on:click={toggleFavorite}>
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-Heart"><path d="M7 3C4.239 3 2 5.216 2 7.95c0 2.207.875 7.445 9.488 12.74a.985.985 0 0 0 1.024 0C21.125 15.395 22 10.157 22 7.95 22 5.216 19.761 3 17 3s-5 3-5 3-2.239-3-5-3z"/></svg>
            </div>
        </div>

        <p>{ record?.description || '' }</p>

        <div class="flex-vertical gap-1">

            <!-- NUTRITIONAL -->
            <div class="nutritional">

                {#if record?.nutritionalValue?.calories}

                    <div>
                        <div>{record.nutritionalValue?.calories}</div>
                        <div>{$t('nutrition.calories')}</div>
                    </div>
                {/if}

                {#if record?.nutritionalValue?.proteins}

                    <div>
                        <div>{record.nutritionalValue?.proteins}{$t('nutrition.gram')}</div>
                        <div>{$t('nutrition.proteins')}</div>
                    </div>
                {/if}

                {#if record?.nutritionalValue?.fats}

                    <div>
                        <div>{record.nutritionalValue?.fats}{$t('nutrition.gram')}</div>
                        <div>{$t('nutrition.fats')}</div>
                    </div>
                {/if}

                {#if record?.nutritionalValue?.carbohydrates}

                    <div>
                        <div>{record.nutritionalValue?.carbohydrates}{$t('nutrition.gram')}</div>
                        <div>{$t('nutrition.carbs')}</div>
                    </div>
                {/if}

            </div>

            <!-- ALLERGENS -->
            {#if ($publishConfigStore.showAllergens)}
                {#if (record?.allergens || []).length > 0}
                <div class="allergens">
                    <span>{$t('allergens.contains')}:</span>
                    {#each (record?.allergens || []) as allergen, index}
                        <span>{ allergen }</span>{#if index < record.allergens.length-1}<span>, </span>{/if}
                    {/each}
                </div>
                {/if}
            {/if}

            <!-- PRICES BLOCK -->
            <div class="prices-block">
                {#each (record?.prices || []) as price, index}
                    <div class="price-item {index > 0 ? 'price-item--secondary' : ''}">

                        <div class="price-label">

                            <span class="price">
                            {#if (publishConfig?.currency) }
                                <span>{ publishConfig.currency } </span>
                            {/if}
                                <span>{ price.price }</span>
                            </span>

                            {#if (price.weight !== undefined)}
                                <span class="weight"> / { price.weight }</span>
                            {/if}

                        </div>

                        {#if (price._count !== undefined)}
                            <button class="inc-button" on:click={decrementItemInCart(record, price, index)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-CircleMinus"><path d="M16 12H8"/><circle cx="12" cy="12" r="10"/></svg>
                            </button>
                            <span>{ price._count }</span>
                            <button class="inc-button" on:click={incrementItemInCart(record, price, index)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-CirclePlus"><path d="M12 8v4m0 0v4m0-4h4m-4 0H8"/><circle cx="12" cy="12" r="10"/></svg>
                            </button>
                        {:else}
                            <button on:click={() => addToCart(record, price, index)}>{$t('addToCart.add')}</button>
                        {/if}
                    </div>
                {/each}
            </div>

        </div>

    </div>

</div>

{/if}
